<template>
  <div class="main-dashboard-panel organization-reports">
    <div class="panel-topnav">
      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">Messages</h3>
        </li>
      </ul>
    </div>
    <Panel v-loading="isThreadListFetchInProgress">
      <div v-if="threadList.length" class="flex" style="max-width: 800px">
        <div
          class="flex-grow-0 flex-shrink-0 chat-thread-list--thread-list"
          :style="{ 'flex-basis': '250px' }"
        >
          <div
            v-for="thread in threadList"
            :key="thread.id"
            data-testid="threadList"
            class="py-4 px-3 cursor-pointer truncate relative hover:bg-yellow-200 border-yellow-500"
            :class="[
              isSelectedThread(thread)
                ? 'font-semibold text-black bg-yellow-400 hover:bg-yellow-400 border-t border-b'
                : 'text-gray-600 border-r',
            ]"
            @click="selectThread(thread)"
          >
            <span class="relative">
              {{ thread.name }}
              <span
                v-if="thread.unread_count > 0"
                class="flex h-2 w-2 absolute bottom-2 left-0 -ml-3"
              >
                <span
                  class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"
                ></span>
                <span
                  class="relative inline-flex rounded-full h-2 w-2 bg-red-500"
                ></span>
              </span>
            </span>
          </div>
        </div>
        <div class="flex-grow messages-list">
          <router-view />
        </div>
      </div>
      <p
        v-if="!isThreadListFetchInProgress && !threadList.length"
        class="mt-4 text-gray-500"
      >
        No started conversations yet.
      </p>
    </Panel>
  </div>
</template>

<script>
import useThreadList from './useThreadList'
import Panel from 'components/common/Panel'
import { ref, watch, computed } from '@vue/composition-api'

export default {
  name: 'ChatThreadList',
  components: { Panel },
  setup(props, { root }) {
    const { isThreadListFetchInProgress, threadList } = useThreadList()

    const selectThread = (thread) => {
      if (root.$route.params.threadId !== thread.id) {
        root.$router.push({
          name: 'chatThreadMessages',
          params: { threadId: thread.id },
        })
      }
    }

    const threadListMap = computed(() => {
      const map = {}
      threadList.value.forEach((thread) => {
        map[thread.id] = thread
      })
      return map
    })

    watch(
      () => threadList.value,
      () => {
        if (root.$route.params.threadId) {
          const thread = threadListMap.value[root.$route.params.threadId]
          if (thread) {
            selectThread(thread)
          }
        } else if (threadList.value.length > 0) {
          selectThread(threadList.value[0])
        }
      },
    )

    const isSelectedThread = (thread) => {
      return root.$route.params.threadId === thread.id
    }
    return {
      threadList,
      isThreadListFetchInProgress,
      isSelectedThread,
      selectThread,
    }
  },
}
</script>

<style lang="scss" scoped>
.chat-thread-list--thread-list {
  height: calc(100vh - 65px - 3 * 16px);
  overflow: auto;
}
</style>
